import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import './SideBarContent.css';
import DashboardIcon from '../../../../images/dashboard_icon.svg';
import LawyerIcon from '../../../../images/white_lawyer.svg';
import PatientIcon from '../../../../images/white_patient.svg';
import PhysicianIcon from '../../../../images/white_physician.svg';
import MainLogo from '../../../components/MainLogoWhite';
import UserIcon from '../../../../images/sidebar_user.svg';
import { LuLogOut } from "react-icons/lu";

interface Props{
    nav: NavigateFunction;
    userRole: string;
    currentPath: string;
    userName: string;
    onLogout: () => void;
}

function SideBarContent({
    nav, userRole, currentPath, userName, onLogout
}: Props) : JSX.Element {

    const sidebarItems = [
        { id: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: <img src={DashboardIcon} alt="Dashboard" /> },
        { id: 'lawyers', label: 'Lawyers', path: '/lawyers', icon: <img src={LawyerIcon} alt="Lawyer" /> },
        { id: 'patients', label: 'Patients', path: '/patients', icon: <img src={PatientIcon} alt="Patient" /> },
        { id: 'physicians', label: 'Physicians', path: '/physicians', icon: <img src={PhysicianIcon} alt="Physician" /> }
      ];

      const handleItemClick = (path: string) => {
        nav(path);
      }

      return(
        <div className="sidebar-content-container">
            <div className="sidebar-header-top">
            <div className="sidebar-header">
                <MainLogo nav={nav}/>
            </div>

            <div className="sidebar-content-item-navigations">
                {sidebarItems.map(tab => (
                    <div key ={tab.id} onClick={() => handleItemClick(tab.path)} className={`sidebar-content-item ${currentPath === tab.path ? 'active' : ''}`}>
                        <span className="sidebar-content-item-img">{tab.icon}</span>
                        <span className="sidebar-content-item-label">{tab.label}</span>
                    </div>
                )
                )}
            </div>
            </div>
            
            <div className="sidebar-content-user-container">
                <img src={UserIcon} alt="user-icon" />
                <p>Welcome</p>
                <h4>{userName}</h4>
                <button onClick={onLogout}><LuLogOut style={{ color: "#dfe6ff"}} /><span>Log Out</span></button>
            </div>
        </div>
      )
}

export default SideBarContent;